module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-Italic-cc9f0cedefdf486f160c42bb0b913d2a.woff";